import configure from '../util/configure';
import { dateFormat } from '../util/date-format';
import dateMath from '../util/date-arithmetic';
import { IDateLocalizer } from '../util/localizers';

export function simpleDateLocalizer(): IDateLocalizer {
  function endOfDecade(date: Date) {
    date = dateMath.add(date, 10, 'year');
    date = dateMath.add(date, -1, 'milliseconds');
    return date;
  }

  function endOfCentury(date: Date) {
    date = dateMath.add(date, 100, 'year');
    date = dateMath.add(date, -1, 'milliseconds');
    return date;
  }

  return {
    formats: {
      date: 'L',
      time: 'LT',
      default: 'lll',
      header: 'MMMM YYYY',
      footer: 'LL',
      weekday: 'dd',
      dayOfMonth: 'DD',
      month: 'MMM',
      year: 'YYYY',

      decade(date: Date, culture: string | undefined, localizer: any) {
        return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfDecade(date), 'YYYY', culture);
      },

      century(date: Date, culture: string | undefined, localizer: any) {
        return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfCentury(date), 'YYYY', culture);
      }
    },

    startOfWeek() {
      return 0;
    },

    parse(value: string) {
      if (!value) {
        return null;
      }
      try {
        return new Date(Date.parse(value));
      }
      catch (err) {
        console.error(err);
      }

      return null;
    },

    format(value: Date, format: string) {
      return dateFormat(value, format);
    }
  };
}

export default function() {
  const localizer = simpleDateLocalizer();
  configure.setDateLocalizer(localizer);
  return localizer;
}
